import type { CardmarketSingleWithPrice } from '../../../../server/src/carddetector/types'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'

function formatEur(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—'
  return `€${n.toFixed(2)}`
}

export type CardMarketSinglesTableProps = {
  items: CardmarketSingleWithPrice[]
}

export function CardMarketSinglesTable({ items }: CardMarketSinglesTableProps) {
  return (
    <div className="rounded-md border overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[88px]">ID</TableHead>
            <TableHead className="w-[88px]">Exp.</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Category</TableHead>
            <TableHead className="text-right">Avg</TableHead>
            <TableHead className="text-right">Low</TableHead>
            <TableHead className="text-right">Trend</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7} className="text-center text-muted-foreground">
                No singles match this search.
              </TableCell>
            </TableRow>
          ) : (
            items.map((row) => {
              const p = row.cardMarketPrice
              return (
                <TableRow key={row.idProduct}>
                  <TableCell className="font-mono text-xs">{row.idProduct}</TableCell>
                  <TableCell className="font-mono text-xs tabular-nums">{row.idExpansion}</TableCell>
                  <TableCell className="max-w-[240px] truncate" title={row.name}>
                    {row.name}
                  </TableCell>
                  <TableCell className="text-muted-foreground text-sm max-w-[160px] truncate" title={row.categoryName}>
                    {row.categoryName}
                  </TableCell>
                  <TableCell className="text-right tabular-nums">{formatEur(p?.avg)}</TableCell>
                  <TableCell className="text-right tabular-nums">{formatEur(p?.low)}</TableCell>
                  <TableCell className="text-right tabular-nums">{formatEur(p?.trend)}</TableCell>
                </TableRow>
              )
            })
          )}
        </TableBody>
      </Table>
    </div>
  )
}
